import { match } from "ts-pattern";
import { XMarkIcon } from "@heroicons/react/20/solid";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { EBanner, useBannerContext } from "../../contexts/Banner";
import classes from "./classes.module.scss";

export default function ProfessionalSpaceLayout() {
	const { openedBanner, closeBanner } = useBannerContext();

	return (
		openedBanner && (
			<div className={classes["root"]}>
				<Typography
					type="span"
					size="medium"
					color="white"
					htmlContent={
						I18n.asset.pages.professional_space.layout.banner[
							match(openedBanner)
								.with(EBanner.DRAFT_PROJECT, () => "draft_project" as const)
								.with(EBanner.PUBLISHED_PROJECT, () => "published_project" as const)
								.exhaustive()
						]
					}
					className={classes["content"]}
				/>
				<div className={classes["close-container"]}>
					<XMarkIcon className={classes["close-icon"]} onClick={closeBanner} color="white" />
				</div>
			</div>
		)
	);
}
